<div class="p-6">
  <h2 class="text-xl font-semibold mb-4 text-white">{{ 'ADMINISTRATION_AVANCEE.CHANGER_PRENOM_NOM.TITLE' | translate
    }}</h2>

  <div class="mb-6">
    <p class="text-sm text-gray-300 mb-4">
      {{ 'ADMINISTRATION_AVANCEE.CHANGER_PRENOM_NOM.DESCRIPTION' | translate }}
    </p>

     <mat-form-field class="w-full mb-4 text-white">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.CHANGER_PRENOM_NOM.IDENTIFIANT' | translate }}</mat-label>
      <input  matInput type="text" [(ngModel)]="identifiantInput">
      <mat-hint>{{ 'ADMINISTRATION_AVANCEE.CHANGER_PRENOM_NOM.HIT' | translate }}</mat-hint>
    </mat-form-field>

     <mat-form-field class="w-full mb-4 text-white">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.CHANGER_PRENOM_NOM.NOUVEAU_PRENOM' | translate }}</mat-label>
      <input matInput type="text" [(ngModel)]="nouveauPrenomInput">
    </mat-form-field>

     <mat-form-field class="w-full mb-4 text-white">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.CHANGER_PRENOM_NOM.NOUVEAU_NOM' | translate }}</mat-label>
      <input matInput type="text" [(ngModel)]="nouveauNomInput">
    </mat-form-field>

    <div class="flex justify-end mr-5 space-x-4">
      <button type="submit" (click)="changerPrenomNom()" [disabled]="isLoading ||
       identifiantInput === '' || !validerEmail(identifiantInput)"
          class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">{{
          'ADMINISTRATION_AVANCEE.CHANGER_PRENOM_NOM.BUTTON_CHANGER' | translate }}</button>
    </div>
  </div>
</div>
